import styled from "styled-components"
import { useStore } from "@state/store"
import { useProjectDataStore } from "@state/projectDataStore"
import TextButton from "@common/ui/TextButton"
import { Cross2Icon } from "@radix-ui/react-icons"
import { FC, useState } from "react"
import useViewsPublicURL from "@src/hooks/useViewsPublicURL"

import { flattenedMap } from "@data/planTypesData"
import SphericalTour from "../SphericalTour"

type ImageDisplayCompareProps = {
  show?: any
  selectedUnit: any
}

const ImageDisplayCompare: FC<ImageDisplayCompareProps> = ({
  show,
  selectedUnit,
}) => {
  const contentControls = useStore((s) => s.contentControls)
  const compareMode = useStore((s) => s.compareMode)

  const { brandingData, viewsData } = useProjectDataStore((s) => ({
    brandingData: s.brandingData,
    viewsData: s.viewsData,
  }))

  const colors = brandingData
  const viewID = selectedUnit?.viewID
  const planID = selectedUnit ? flattenedMap[selectedUnit?.planType] : null

  return (
    <Wrapper
      colors={colors}
      contentControls={contentControls.index}
      compareMode={compareMode}
    >
      {show && (
        <TextButton
          color="secondary"
          className="close-button"
          onClick={() => show(false)}
          icon={<Cross2Icon color="#fff" />}
          iconPosition="right"
          variant="outline"
        />
      )}
      {contentControls?.index === 0 ? (
        <>
          <Image
            src={`assets/imgs/plans/TYPE-${planID}.svg`}
            alt=""
            isview={false}
          />
          <>
            <img
              src={"assets/icons/compass.svg"}
              style={{
                position: "absolute",
                width: "6rem",
                height: "6rem",
                bottom: "0",
                right: "0",
                objectFit:"contain"
              }}
            />
          </>
        </>
      ) : (
        <Bubble>
          <SphericalTour
            unit={[selectedUnit]}
            texture={"/assets/imgs/view.webp"}
            initialPosition={[0, 0, 0]}
          />
        </Bubble>
      )}
    </Wrapper>
  )
}

export default ImageDisplayCompare

const Wrapper = styled.div<{
  colors: any
  contentControls: number
  compareMode: boolean
}>`
  width: 100%;
  height: 100%;
  position: absolute;

  .close-button {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 2rem;
    z-index: 1;
    background-color: var(--secondary);
    border-radius: 5px;
  }
`

const Image = styled.img<{ isview: boolean }>`
  position: absolute;
  left: 10%;
  top: 5%;
  width: 80%;
  height: 90%;
  object-fit: contain;
`
const Bubble = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  & canvas {
    width: 100% !important;
    height: 100% !important;
  }
`
